import { Dataset } from 'generic/dataset'
import * as Types from './types'
import * as RexConstants from '../rex/constants'

export const loadUserPreferences = (communityId: string): Promise<Types.UserPreference[]> => {
  return new Dataset()
    .loadCommunityDataset('userAiPreferences', communityId)
    .then((response) => {
      const preferences = response[0] || []
      const userPreferences = preferences.map((pref) => ({
        key: pref.name,
        value: pref.id,
        description: pref.name,
        options: typeof pref.options === 'string' ? JSON.parse(pref.options) : pref.options,
        is_default: pref.is_default
      }))

      // Add default preference as first item when only one user preference is found
      if (userPreferences.length === 0) {
        userPreferences.unshift({
          key: 'default',
          value: 'default',
          description: 'Default',
          options: {
            tone: RexConstants.ToneDropdownOptions[0].value, // 'Friendly'
            length: RexConstants.LengthDropdownOptions[1].value, // 75 (Medium)
            language: RexConstants.LanguageDropdownOptions[0].value, // 'English'
            emoji: RexConstants.EmojiDropdownOptions[0].value, // 0 (No Emojis)
          },
          is_default: true
        })
      }

      // Add Custom option at the end
      userPreferences.push({
        key: 'custom',
        value: 'custom',
        description: 'Custom',
        options: null,
        is_default: false
      })

      return userPreferences
    })
}

export const getDefaultPreference = (userPreferences: Types.UserPreference[]): Types.UserPreference => {
  return userPreferences.find(p => p.is_default) ||
         userPreferences[0] ||
         { key: 'custom', value: 'custom', description: 'Custom', options: null, is_default: false }
}